import { init as initProductDetails } from './details';
import { init as initQtyControls } from './qty-controls';
import { init as initImageGalleryMobile } from './image-gallery-mobile';
import { init as initImageGalleryDesktop } from './image-gallery-desktop';
import { init as initImageLightbox } from './image-lightbox';
import { init as initAccordion } from './accordion';
import { init as initUpsell } from './upsell';
import { init as initCarousel } from './carousel';
import { init as initSMP } from './smp';
import { init as initRecentlyViewed } from './recently-viewed';
import { init as initZoom } from './zoom';
import { init as initGtm } from './gtm';
import { init as initSwatchSlider } from './swatch-slider';
import { init as initOkendo } from './okendo';
import { init as initStoq } from './stoq';
import { init as initMultistepForm } from '../gift-wrapping/mount';
import { init as initEmbroideryModal } from '../product-embroidering/mount';
const logErrors = function(err) {
    console.error(err);
};
initProductDetails().catch(logErrors);
initQtyControls().catch(logErrors);
initImageGalleryMobile().catch(logErrors);
initImageGalleryDesktop().catch(logErrors);
initImageLightbox().catch(logErrors);
initUpsell().catch(logErrors);
initCarousel().catch(logErrors);
initRecentlyViewed().catch(logErrors);
initSMP().catch(logErrors);
initAccordion().catch(logErrors);
initZoom().catch(logErrors);
initGtm().catch(logErrors);
initSwatchSlider().catch(logErrors);
initOkendo().catch(logErrors);
initStoq().catch(logErrors);
initMultistepForm().catch(logErrors);
initEmbroideryModal().catch(logErrors);
